<template>
  <div
    class="d-flex-row space-between"
    v-for="packSelectedOption in selectedOptions"
    :key="packSelectedOption"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ packSelectedOption.title }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(packSelectedOption) }}
    </p>
  </div>

  <div
    class="d-flex-row space-between"
    v-if="checkoutStore.getSelectedQueue?.value"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ selectedQueue?.title }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(selectedQueue) }}
    </p>
  </div>
  <div
    class="d-flex-row space-between"
    v-if="checkoutStore.getSelectedServer?.value"
  >
    <p class="t-grey font-family-2 regular-l">
      {{ selectedServer?.title }}
    </p>
    <p
      class="t-white font-family-2 bold-l"
      v-if="checkoutStore.fullPack?.slug !== 'buy-wow-gold'"
    >
      {{ renderPrice(selectedServer) }}
    </p>
  </div>
  <div class="d-flex-row space-between" v-if="checkoutStore.getSelectedRole">
    <p class="t-grey font-family-2 regular-xl">
      {{ selectedRole?.title }}
    </p>
    <p class="t-white font-family-2 bold-l">
      {{ renderPrice(selectedRole) }}
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      let gamePackOption = this.getGamePack.pack_extra_options || [];
      const packSelectedOptions = gamePackOption.filter((option) =>
        Object.keys(this.checkoutStore.getPackExtraOptions).some((value) => {
          return this.checkoutStore.getPackExtraOptions[value] === option.id;
        })
      );
      return packSelectedOptions;
    },

    selectedQueue() {
      const queues = this.getGamePack.pack_extra_options || [];
      return queues.find(
        (queue) => queue.id == this.checkoutStore.getSelectedQueue?.value
      );
    },

    selectedServer() {
      let servers = this.getGame.servers;
      if (this.getGame?.slug === "world-of-warcraft-boost") {
        servers = this.getGamePack.servers;
      }

      const server = servers?.find(
        (server) => server.id == this.checkoutStore.getSelectedServer?.value
      );
      return server;
    },
    selectedRole() {
      const role = this.getGame?.roles?.find(
        (role) => role.id == this.checkoutStore.getSelectedRole
      );
      return role;
    },
  },

  methods: {
    renderPrice(option) {
      if (!option) {
        return "";
      }
      if (option.type === "variable") {
        if (option.price_type === 0) {
          return `+${option.price}%`;
        } else if (option.price_type === 1) {
          return `-${option.price}%`;
        }
      }
      if (option.type === "fixed") {
        if (option.price_type === 0) {
          return `+${option.price}$`;
        } else if (option.price_type === 1) {
          return `-${option.price}$`;
        }
      }
      if (option.type === "free") {
        return this.$t("checkout.free");
      }
      return option.price;
    },
  },
  setup() {
    // "checkoutStore.getPackExtraOptions",
    //   "getGamePack",
    //   "checkoutStore.getSelectedQueue?.value",
    //   "checkoutStore.getSelectedServer?.value",
    //   "checkoutStore.getSelectedRole",
    //   "getGame",
    const { getGame, getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();
    return {
      getGame,
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
